// import httpUtil from "../assets/script/utils/http";

const state = {
  leftShow: false,
  rightShow: false,
  hotShow: false,
  scShow: false,
  bcShow: false,
  editorShow: true,
  wycShow: false,
  rightTitle: "",
  contentHeight: 0,
  contentWidth: 0,
  showLoginDialogs: false,
  showMessage: "",
  showBtn: "",
  showPrompt: false,
  showUpgrade: false,
  showUpgradeMessage: "",
  showMessageBox: false,
  showTitle: "",
  headerFun: 0,
  importFile: 0,
  showGift: false,
  useGift: true,
  giftTime: "",
  iswycShowMsg: false
};

const mutations = {
  setShowLoginDialogs(state, ishow) {
    state.showLoginDialogs = ishow;
  },
  setShowMessage(state, msg) {
    state.showMessage = msg;
  },
  setShowBtn(state, msg) {
    state.showBtn = msg;
  },
  setShowTitle(state, msg) {
    state.showTitle = msg;
  },
  setshowPrompt(state, ishow) {
    state.showPrompt = ishow;
  },
  setshowUpgrade(state, ishow) {
    state.showUpgrade = ishow;
  },
  setshowUpgradeMessage(state, msg) {
    state.showUpgradeMessage = msg;
  },
  setShowMessageBox(state, msg) {
    state.showMessageBox = msg;
  },
  setHeaderFun(state, msg) {
    state.headerFun = msg;
  },
  setImportFile(state, msg) {
    state.importFile = msg;
  },
  setShowGift(state, msg) {
    state.showGift = msg;
  },
  setUseGift(state, msg) {
    state.useGift = msg;
  },
  setGiftTime(state, msg) {
    state.giftTime = msg;
  },
  setWycShowMsg(state, msg) {
    state.iswycShowMsg = msg;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
